module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAAXNSR0IArs4c6QAAAU5JREFUKBV1k81KAlEYhs+oLcSgPwolIohWQYHQptp5A15BO29ABAtUZkrJiEDwDroE8T76wWgVbooWRUUQtJLpeQfTo8188Pid7+eZA6Ma3/cL4BgrqFfBgzmrPXGMUeXhiKUZa7LCeQfOomSJigNosDSrwnGcG9WQAcnz5In4E9XcgguWdJvka9IppKFJf4E8CltUcw0uWdpQgXxLkrwMunmRHMS0qKaefM5SVgXyHekEJOvmJbIJE9VPgstSTgVyj+SBpECOEpmbOBSRN1Ug35OuQC+slOAjKgYM2giPWuABenmH8ArtKPGHYRNJX4ukbZILH1Ch/xYmfjL0GPbJkvSSqqCbqvTfyWZafKbnMtSSpF1SBV5Akh4ahC0+0Kkz/NYEaY9Uhieo0f8ij4OFLhzD6LfKeR860ILgZzg2hicGYf+Odfo1SP0Tho1fShOZjQvps2EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/product-icon.png
// module id = c8BT
// module chunks = 1